var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCronometro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_1035",
    "data-name": "Raggruppa 1035",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.237,
    height: 45.429,
    viewBox: "0 0 40.237 45.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1035",
    "data-name": "Rettangolo 1035",
    width: 40.237,
    height: 45.429,
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1034",
    "data-name": "Raggruppa 1034",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7037",
    "data-name": "Tracciato 7037",
    d: "M19.584,39.78A19.595,19.595,0,1,1,39.179,20.185,19.611,19.611,0,0,1,19.584,39.78m0-36.81A17.216,17.216,0,1,0,36.8,20.185,17.231,17.231,0,0,0,19.584,2.969",
    transform: "translate(0 5.65)",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7038",
    "data-name": "Tracciato 7038",
    d: "M2.494,1.626,1.109,3.55,9.294,9.43,5.339,14.886l1.925,1.385,5.372-7.328Z",
    transform: "translate(10.62 15.566)",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7039",
    "data-name": "Tracciato 7039",
    d: "M10.633,6.681H7.873V2.652H4.236V6.681h-2.8V.029h9.2Z",
    transform: "translate(13.725 0.283)",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7040",
    "data-name": "Tracciato 7040",
    d: "M7.479,9.818l-1.5-1.84,2.453-2-1.5-1.84-2.453,2-1.5-1.829L7.257.8l4.515,5.509Z",
    transform: "translate(28.473 7.643)",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1034",
    "data-name": "Rettangolo 1034",
    width: 13.303,
    height: 2.908,
    transform: "translate(12.901)",
    fill: "#e20613",
    stroke: "#e20613",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCronometro);
export default __webpack_public_path__ + "static/media/menu-cronometro.922216558bc574a05a754f529940ba2b.svg";
export { ForwardRef as ReactComponent };